import React from 'react';

const DeliveryDriver = () => {
  const styles = {
    badgeRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 10,
      alignItems: 'center',
      marginTop: 6,
      marginBottom: 16,
      padding: '10px 12px',
      borderRadius: 12,
      border: '1px solid #e5e7eb',
      background: '#f9fafb',
      fontSize: 13.5,
      color: '#111827',
      lineHeight: 1.4,
    },
    badgeDot: { color: '#9ca3af' },

    p: {
      fontSize: 14.5,
      lineHeight: 1.75,
      margin: '10px 0',
      color: '#111827',
    },

    h2: {
      fontSize: 18,
      margin: '26px 0 10px',
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    h3: {
      margin: '18px 0 8px',
      fontSize: 15,
      fontWeight: 900,
      letterSpacing: '-0.01em',
      color: '#111827',
    },

    ul: {
      margin: '10px 0 10px 22px',
      fontSize: 14.5,
      lineHeight: 1.75,
      color: '#111827',
    },

    notice: {
      marginTop: 14,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #fde68a',
      background: '#fffbeb',
      fontSize: 14,
      lineHeight: 1.6,
      color: '#111827',
    },

    highlightBox: {
      marginTop: 18,
      padding: 14,
      borderRadius: 12,
      border: '1px solid #dbeafe',
      background: '#eff6ff',
      lineHeight: 1.6,
    },
    highlightText: {
      margin: 0,
      fontSize: 14.5,
      color: '#111827',
    },
  };

  return (
    <div>
      <h2 style={styles.h2}>Delivery Driver – Local Food Delivery (Chicago)</h2>

      <div style={styles.badgeRow}>
        <span>
          📍 <strong>Chicago &amp; Nearby Areas</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🚗 <strong>Flexible Hours</strong>
        </span>
        <span style={styles.badgeDot}>•</span>
        <span>
          🤝 <strong>Local Routes</strong>
        </span>
      </div>

      <p style={styles.p}>
        We’re a local food-delivery startup looking for reliable delivery drivers to help deliver
        meals from nearby restaurants to customers across Chicago and surrounding neighborhoods.
      </p>

      <p style={styles.p}>
        This is a great opportunity if you’re looking for flexible work, steady orders, and a
        supportive local team.
      </p>

      <h3 style={styles.h3}>What You’ll Do</h3>
      <ul style={styles.ul}>
        <li>Pick up food orders from local restaurants</li>
        <li>Deliver orders safely and on time to customers</li>
        <li>Communicate clearly with the team when needed</li>
        <li>Represent our platform professionally</li>
      </ul>

      {/* ✅ Background check notice (requested line) */}
      <div style={styles.notice}>
        <strong>Important:</strong> Employment is subject to a satisfactory background check.
      </div>

      <h3 style={styles.h3}>What We’re Looking For</h3>
      <ul style={styles.ul}>
        <li>Valid driver’s license</li>
        <li>Access to a car, scooter, or bike (depending on area)</li>
        <li>Familiarity with Chicago streets and neighborhoods</li>
        <li>Reliable, punctual, and customer-friendly</li>
        <li>Comfortable using a smartphone app</li>
      </ul>

      <h3 style={styles.h3}>What We Offer</h3>
      <ul style={styles.ul}>
        <li>Flexible working hours</li>
        <li>Local delivery routes</li>
        <li>Supportive team environment</li>
        <li>Easy onboarding</li>
        <li>Opportunity for consistent work</li>
      </ul>

      <div style={styles.highlightBox}>
        <p style={styles.highlightText}>
          If you’re dependable, enjoy driving, and want to be part of a growing local delivery
          team,&nbsp;
          <strong>apply today!</strong>
        </p>
      </div>

      <div
        style={{
          marginTop: 16,
          padding: 16,
          borderRadius: 14,
          border: '2px solid #FF6138',
          background: '#fff2ecff',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ minWidth: 220 }}>
            <div
              style={{
                fontSize: 14.5,
                fontWeight: 900,
                color: '#111827',
                letterSpacing: '-0.01em',
              }}
            >
              Apply by Email
            </div>
            <div style={{ marginTop: 6, fontSize: 13.5, color: '#374151', lineHeight: 1.6 }}>
              Email your <strong>CV/Resume</strong> and mention the <strong>Job Title</strong> in
              the subject line.
            </div>
          </div>

          <a
            href='mailto:jobs@singlecombo.com?subject=Application%20-%20Delivery%20Driver%20(Chicago)'
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '10px 12px',
              borderRadius: 12,
              border: '1px solid #dbeafe',
              background: '#eff6ff',
              color: '#111827',
              textDecoration: 'none',
              fontSize: 13.5,
              fontWeight: 800,
              whiteSpace: 'nowrap',
            }}
            aria-label='Email jobs@singlecombo.com'
          >
            ✉️ jobs@singlecombo.com
          </a>
        </div>

        <div
          style={{
            marginTop: 12,
            paddingTop: 12,
            borderTop: '1px solid #e5e7eb',
            display: 'grid',
            gap: 8,
          }}
        >
          <div style={{ fontSize: 13, color: '#6b7280' }}>
            <strong style={{ color: '#111827' }}>Subject:</strong> Application - Delivery Driver
            (Chicago)
          </div>
          <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>
            <strong style={{ color: '#111827' }}>Include:</strong> Name • Phone • Area/Neighborhood
            • Vehicle type (Car/Scooter/Bike) • Availability
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryDriver;
